import React, { useCallback, useImperativeHandle, useRef } from 'react';
import CRCSearch from '../../../components/SearchInput/CRCSearch';
import CityHallSearch from '../../../components/SearchInput/CityHallSearch';
import CountySearch from '../../../components/SearchInput/CountySearch';
import { get, isFunction } from 'lodash';

const SearchHeader = React.forwardRef((props: PaymentsReports.ISearchHeaderProps, ref: any) => {
  const {
    isAdmin,
    cityHallSelect,
    onChange: onChangeEvent,
    onUpdate,
    onCityHallChange: onCityHallChangeEvent,
    children
  } = props;

  const cityHallSearchRef = useRef<any>(ref && ref.current && ref.current.cityHallSearch && ref.current.cityHallSearch.current);
  const crcSearchRef = useRef<any>(ref && ref.current && ref.current.crcSearch && ref.current.crcSearch.current);
  const countySearchRef = useRef<any>(ref && ref.current && ref.current.countySearch && ref.current.countySearch.current);

  useImperativeHandle(ref, () => ({
    cityHallSearch: cityHallSearchRef,
    crcSearch: crcSearchRef,
    countySearch: countySearchRef,
    get(searchKey: string) {
      return get(ref, ['current', searchKey, 'current', 'selectedData']);
    }
  }), [cityHallSearchRef, crcSearchRef, countySearchRef]);

  const onCityHallChange = useCallback((place: any) => {
    if (isFunction(onCityHallChangeEvent)) return onCityHallChangeEvent(place);
  }, [onCityHallChangeEvent]);

  const onChange = useCallback(async (place: any) => {
    if (cityHallSearchRef.current && isFunction(cityHallSearchRef.current.reset)) cityHallSearchRef.current.reset();
    if (crcSearchRef.current && isFunction(crcSearchRef.current.reset)) crcSearchRef.current.reset();
    if (countySearchRef.current && isFunction(countySearchRef.current.reset)) countySearchRef.current.reset();

    if (isFunction(onChangeEvent)) await onChangeEvent(place);

    if (place) {
      if (place.cityHallId) await onCityHallChange(place);
    } else {
      await onCityHallChange(place);
    }

  }, [onChangeEvent, onCityHallChange]);

  return (
    <>
      {children}

      <div className={`search-header-container ${isAdmin ? '' : 'search-header-container-single'}`}>
        {cityHallSelect &&
          <CityHallSearch className="my-5" ref={cityHallSearchRef} onChange={onChange} onUpdate={onUpdate} />}
        {isAdmin && <CRCSearch className="my-5" ref={crcSearchRef} onChange={onChange} onUpdate={onUpdate} />}
        {isAdmin && <CountySearch className="my-5" ref={countySearchRef} onChange={onChange} onUpdate={onUpdate} />}
      </div>
    </>
  );
});

export default React.memo(SearchHeader);